import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const AllergiesModal = ({show, setShow, data}) => {

    const handleClose = () => setShow(false);

    console.log('resul', data)

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Allergies Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    // data?.length === 0? 
                    // <h4>No result</h4> :
                    // data.map((item) => (
                        <div className="d-flex align-items-between gap-3 justify-content-center h-100">
                            <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center w-20 h-50 mt-4 ">
                                <i class="ri-capsule-fill fs-1"></i>
                            </div>
                            <div>
                                <h6 className="mb-0">
                                    <label className=''>Allergy</label>
                                    <p className='fs-sm text-primary text-capitalize'>
                                    {data?.allergy ?? "---"}
                                    </p>
                                </h6>
                                <h6 className="mb-0">
                                    <label className=''>Drug</label>
                                    <p className='fs-sm text-danger'>
                                    {data?.drugGeneric.name?? "---"}
                                    </p>
                                </h6>
                                <h6 className="mb-0">
                                    <label className=''>Reaction</label>
                                    <p className='fs-sm'>
                                    {data?.reaction?? "---"}    
                                    </p>
                                </h6>
                            </div>
                        </div>
                    // ))
                }
            </Modal.Body>
            <Modal.Footer>
                {/* <Button variant="primary" onClick={handleClose}>
                    Yes! Verify
                </Button>
                */}
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button> 
            </Modal.Footer>
        </Modal>
    )
}

export default AllergiesModal
